import { Component, Input } from '@angular/core'

import { DataDisplayProps } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-credit-card-data-display',
  templateUrl: './data-display.component.html'
})
export class DataDisplayComponent {

  /**
   * Title
   */
  @Input() title: DataDisplayProps['title'];

  /**
   * SubTitle
   */
  @Input() subtitle: DataDisplayProps['subtitle'];

  /**
   * Description
   */
  @Input() description: DataDisplayProps['description'];

  /**
   * Size
   */
   @Input() size: DataDisplayProps['size'];

}